"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArraySource = void 0;
const flow_connect_1 = require("flow-connect");
const core_1 = require("flow-connect/core");
const ui_1 = require("flow-connect/ui");
class ArraySource extends core_1.Node {
    constructor() {
        super();
    }
    setupIO() {
        this.addTerminals([{ type: core_1.TerminalType.OUT, name: "array", dataType: "array" }]);
    }
    created(options) {
        const { width = 180, name = "Array Source", style = {}, state = {} } = options;
        this.width = width;
        this.name = name;
        this.state = Object.assign(Object.assign({}, ArraySource.DefaultState), state);
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.setupUI();
        this.setupListeners();
        this.checkNumber();
        this.checkRange();
    }
    process() {
        this.checkNumber();
        this.checkRange();
        let values = [];
        if (this.state.range) {
            for (let i = this.state.min; i <= this.state.max; i += this.state.step)
                values.push(i);
        }
        else {
            if (!this.arrayInput.inputEl.validity.patternMismatch) {
                if (!this.arrayInput.value)
                    return;
                values = this.arrayInput.value.split(",");
                if (this.state.number)
                    values = values.map((item) => Number(item.trim()));
            }
        }
        this.setOutputs(0, values);
    }
    checkNumber() {
        this.rangeLayout.visible = this.state.number;
    }
    checkRange() {
        if (this.state.number && this.state.range) {
            this.arrayInput.visible = false;
            this.rangeStack.visible = true;
        }
        else {
            this.arrayInput.visible = true;
            this.rangeStack.visible = false;
        }
    }
    setupUI() {
        this.numberToggle = this.createUI("core/toggle", {
            propName: "number",
            input: true,
            output: true,
            height: 10,
            style: { grow: 0.2 },
        });
        this.rangeToggle = this.createUI("core/toggle", {
            propName: "range",
            input: true,
            output: true,
            height: 10,
            style: { grow: 0.2 },
        });
        this.rangeLayout = this.createUI("core/x-layout", {
            childs: [this.createUI("core/label", { text: "Range ?", style: { grow: 0.4 } }), this.rangeToggle],
            style: { spacing: 10 },
        });
        this.minInput = this.createUI("core/input", {
            propName: "min",
            height: 20,
            style: { type: ui_1.InputType.Number, grow: 0.4, step: "any" },
        });
        this.maxInput = this.createUI("core/input", {
            propName: "max",
            height: 20,
            style: { type: ui_1.InputType.Number, grow: 0.4, step: "any" },
        });
        let rangeInputLayout = this.createUI("core/x-layout", {
            childs: [
                this.minInput,
                this.createUI("core/label", { text: "to", style: { grow: 0.2, align: flow_connect_1.Align.Center } }),
                this.maxInput,
            ],
            style: { spacing: 5 },
        });
        this.stepInput = this.createUI("core/input", {
            propName: "step",
            height: 20,
            style: { type: ui_1.InputType.Number, step: "any", grow: 0.6 },
        });
        this.rangeStack = this.createUI("core/stack", {
            childs: [
                rangeInputLayout,
                this.createUI("core/x-layout", {
                    childs: [this.createUI("core/label", { text: "Step", style: { grow: 0.4 } }), this.stepInput],
                    style: { spacing: 5 },
                }),
            ],
            style: { spacing: 10 },
        });
        this.arrayInput = this.createUI("core/input", {
            propName: "rawInput",
            value: "",
            height: 20,
            style: { pattern: "^[^,]+(s*,s*[^,]+)*$" },
        });
        this.ui.append([
            this.createUI("core/x-layout", {
                childs: [this.createUI("core/label", { text: "Numbers ?", style: { grow: 0.4 } }), this.numberToggle],
                style: { spacing: 10 },
            }),
            this.rangeLayout,
            this.rangeStack,
            this.arrayInput,
        ]);
    }
    setupListeners() {
        this.watch("min", () => this.process());
        this.watch("max", () => this.process());
        this.watch("number", () => this.process());
        this.watch("range", () => this.process());
        this.watch("step", () => this.process());
        this.watch("rawInput", () => this.process());
    }
}
exports.ArraySource = ArraySource;
ArraySource.DefaultState = { number: true, range: false, min: 0, max: 100, step: 0.1, rawInput: "" };
